import React from 'react';
import Diploma from './Diploma';
import './diplomaPage.css';
import { Link } from 'react-router-dom';

const DiplomaPage = () => {
  return (
    <div className="diploma-page">

      <div className="diploma-success">
        <span className="diploma-success-icon">🎉</span>

        <h1>Felicitari!</h1>

        <p>
          Ai finalizat cu succes cursul <b>Bazele contabilitatii</b>.
          Certificatul tau este gata.
        </p>
      </div>

      <Diploma />

  <div className="diploma-extra-actions">



  <Link
    to="/check-certification"
    className="diploma-action-btn"
  >
    Verifica certificatul
  </Link>

</div>

    </div>
  );
};

export default DiplomaPage;